export default __webpack_public_path__ + "static/media/6_4.163d6d2d.png";